import { render, staticRenderFns } from "./change-duration.vue?vue&type=template&id=48f577a9&"
import script from "./change-duration.vue?vue&type=script&lang=js&"
export * from "./change-duration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports